export default "__VITE_ASSET__16636d46__"